export const MatcherCategoryFilters = {
  SUPPLY: 'supply',
  DRUG: 'drug',
  LAB: 'lab',
  PROCEDURE: 'procedure',
  GROOMING: 'grooming',
  BOARDING: 'boarding',
  FOOD: 'food',
  VACCINATIONS: 'vaccinations',
  DIAGNOSIS: 'diagnosis'
};

export const MatcherCategoryFiltersToLabels = [
  { value: MatcherCategoryFilters.SUPPLY, label: 'Supply' },
  { value: MatcherCategoryFilters.DRUG, label: 'Drug' },
  { value: MatcherCategoryFilters.LAB, label: 'Lab' },
  { value: MatcherCategoryFilters.PROCEDURE, label: 'Procedure' },
  { value: MatcherCategoryFilters.GROOMING, label: 'Grooming' },
  { value: MatcherCategoryFilters.BOARDING, label: 'Boarding' },
  { value: MatcherCategoryFilters.FOOD, label: 'Food' },
  { value: MatcherCategoryFilters.VACCINATIONS, label: 'Vaccinations' },
  { value: MatcherCategoryFilters.DIAGNOSIS, label: 'Diagnosis' }
];

export const MatcherInputFileTypes = {
  AVIMARK: 'avimark',
  AVIMARK2: 'avimark2',
  AVIMARK3: 'avimark3',
  AVIMARKEXPORT: 'avimarkexport',
  CHEWY: 'chewy',
  CHEWYDRUG: 'chewydrug',
  CHEWYRXFOOD: 'chewyrxfood',
  COMMON: 'common',
  CORNERSTONE: 'cornerstone',
  CORNERSTONEPRICE: 'cornerstoneprice',
  DIAGNOSISLIST: 'diagnosislist',
  DVM: 'dvm',
  DVMAX: 'dvmax',
  DVMAX2: 'dvmax2',
  DVMAX3: 'dvmax3',
  EVETPRACTICE: 'evetpractice',
  EVETPRACTICEINV: 'evetpracticeinv',
  EVETPRACTICELABS: 'evetpracticelabs',
  EVETPRACTICEPROCEDURES: 'evetpracticeprocedures',
  EZVET: 'ezvet',
  HEAL: 'heal',
  IMPROMED: 'impromed',
  IMPROMEDADVANTAGE: 'impromedadvantage',
  IMPROMEDBIG: 'impromedbig',
  INFINITYNEW: 'infinitynew',
  INFINITYOLD: 'infinityold',
  INFINITYOLDMULTI: 'infinityoldmulti',
  LOCALFOODCATALOG: 'localfoodcatalog',
  MWI: 'mwi',
  PSI: 'psi',
  PVA: 'pva',
  RHAPSODY: 'rhapsody',
  RHAPSODYCATALOG: 'rhapsodycatalog',
  PRICELISTMATCHER: 'pricelistmatcher',
  VETCOVE: 'vetcove',
  VETTER: 'vetter',
  VETTER2: 'vetter2',
  VETTERHISTORY: 'vetterhistory',
  VTECH: 'vtech',
  VTECHAMC: 'vtechamc',
  VTECHOLD: 'vtechold'
};
